import i18n from "i18n-js";
import { getDefaultLanguage, setLanguage as setLanguageUtil } from "./language";

const translationGetters = {
  en: require("../translations/en.json"),
  ru: require("../translations/ru.json"),
  es: require("../translations/es.json"),
  de: require("../translations/de.json"),
  fr: require("../translations/fr.json"),
  ja: require("../translations/ja.json"),
};

const translations = i18n.t;

// set i18n-js config
i18n.defaultLocale = "en";
i18n.fallbacks = true; // For unknown language fall back to English
i18n.translations = {
  en: translationGetters.en,
  ru: translationGetters.ru,
  es: translationGetters.es,
};

let languageTag = getDefaultLanguage();
if (!Object.keys(i18n.translations).includes(languageTag)) {
  languageTag = i18n.defaultLocale;
}
i18n.locale = languageTag;

function setLanguage(lang) {
  setLanguageUtil(lang);
  i18n.locale = lang;
}

export { translations, languageTag, setLanguage };
